<template>
  <grid :gridConfigUrl="gridConfigUrl">
  </grid>
</template>
<script>
  import Grid from '../../components/grid/grid.vue'
  import GridMenuA from '../../components/grid-menu/grid-menu-a.vue'
  import GridTableHeaderCol from '../../components/grid-menu/grid-table-col.vue'
  import util from '../../libs/util'
  export default {
    components: {
      Grid,
      GridMenuA,
      GridTableHeaderCol
    },
    name: 'site-config-manage',
    data() {
      return {
        gridConfigUrl: ''
      }
    },
    created() {
      this.gridConfigUrl = this.$route.meta.url
    },
    methods: {
      toAdd () {
        util.changeRouter(this, {
          name: 'addSiteConfig'
        })
      },
      toUpdate (row) {
        util.changeRouter(this, {
          name: 'editSiteConfig',
          params: {
            id: row.id
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/site-manage/site-config-manage.vue